/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Intermediary_Format_LabelInputs */

const en_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intermediary Format`)
};

const fr_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format intermediaire`)
};

const de_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwischenformat`)
};

const it_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato intermedio`)
};

const ru_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Промежуточный формат`)
};

const es_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato Intermediario`)
};

const zh_cn2_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中间格式`)
};

const ja_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中間形式`)
};

const hi_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मध्यवर्ती प्रारूप`)
};

const pt_pt2_drastic_tech_intermediary_format_label = /** @type {(inputs: Drastic_Tech_Intermediary_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato intermediário`)
};

/**
* | output |
* | --- |
* | "Intermediary Format" |
*
* @param {Drastic_Tech_Intermediary_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_intermediary_format_label = /** @type {((inputs?: Drastic_Tech_Intermediary_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Intermediary_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_intermediary_format_label(inputs)
	if (locale === "de") return de_drastic_tech_intermediary_format_label(inputs)
	if (locale === "it") return it_drastic_tech_intermediary_format_label(inputs)
	if (locale === "ru") return ru_drastic_tech_intermediary_format_label(inputs)
	if (locale === "es") return es_drastic_tech_intermediary_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_intermediary_format_label(inputs)
	if (locale === "ja") return ja_drastic_tech_intermediary_format_label(inputs)
	if (locale === "hi") return hi_drastic_tech_intermediary_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_intermediary_format_label(inputs)
	return en_drastic_tech_intermediary_format_label(inputs)
});